import React from "react";

const DataTableInfo = ({ numberPerPage, totalItems, shownItems, t }) => {
  return (
    <div
      className="dataTables_info"
      id="kt_table_1_info"
      role="status"
      aria-live="polite"
    >
      {t("Affichage de")} {shownItems || 0} {t("sur")} {totalItems}{" "}
      {t("données")}
    </div>
  );
};

export default DataTableInfo;
